export enum EAuthPage {
  LogIn      = 'login',
  ForgotPass = 'forgot-password',
  ResetPass  = 'reset-password',
}
